//src/hooks/useFirmasReserva.ts
import { useQuery } from "@tanstack/react-query";
import { fetchFirmasReserva, FirmaDet } from "../api/reports";

export const useFirmasReserva = (reservaId?: number) =>
  useQuery<FirmaDet[]>({
    queryKey: ["firmasReserva", reservaId],
    queryFn: () => fetchFirmasReserva(reservaId!),
    enabled: !!reservaId,
    staleTime: 5 * 60_000,
  });
